module.exports = __webpack_public_path__ + "static/media/barbell-plate-1500.45a42540.png";